
















import Vue, { VueConstructor } from 'vue';

export default (Vue as VueConstructor<
  Vue & { $refs: { content: HTMLElement } }
>).extend({
  name: 'GSideNavigationLayout',
  data() {
    return {
      topLinks: [
        { text: 'ダッシュボード', to: '/exhibitor/dashboard', icon: 'dashboard' },
        { text: 'お問い合わせ一覧', to: '/exhibitor/contact', icon: 'contact' },
        { text: '来場者一覧', to: '/exhibitor/visitors', icon: 'visitors' },
      ],
      mainLinks: [
        { text: 'ブランド', to: '/exhibitor/brand', icon: 'brand' },
        { text: 'ブース', to: '/exhibitor/booth', icon: 'booth' },
        { text: '商品', to: '/exhibitor/item', icon: 'item' },
      ],
      subLinks: [
        {
          text: 'よくある質問',
          to: 'https://docs.google.com/document/d/1WVoGexkRo19NeqKxqxyiK2dxa5-rXIusmo1l_LfxaTQ/edit?usp=sharing',
          icon: 'faq',
          isExternalSite: true,
        },
        { text: 'アカウント', to: '/exhibitor/account', icon: 'account' },
      ],
    };
  },
  watch: {
    $route() {
      this.scrollTop();
    },
  },
  methods: {
    scrollTop() {
      const content = this.$refs.content;
      content.scrollTop = 0;
    },
  },
});
